import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
import { ref, watch } from "vue";
// 定义Props
export default /*#__PURE__*/_defineComponent({
  __name: 'YTabs2',
  props: {
    data: {
      type: Object,
      default: () => []
    },
    modelValue: {
      type: Number,
      default: 0
    },
    from1start: {
      //从1开始，为了保证和后台传参的一致性，比如在广告位管理
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const allTabs = ref([]);
    const curTab = ref(0);
    allTabs.value = props.data;
    curTab.value = props.modelValue;
    watch(() => props.modelValue, v => {
      if (props.from1start) {
        v = v - 1;
      }
      curTab.value = v;
    }, {
      immediate: true
    });
    // 点击事件
    function onClick(i) {
      if (props.from1start) {
        i = i + 1;
      }
      emit("update:modelValue", i);
      emit("change", i);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("ul", {
        class: _normalizeClass([_ctx.css.tab_wrap, "flex"])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTabs.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          onClick: $event => onClick(index),
          class: _normalizeClass({
            [_ctx.css.active]: index == curTab.value
          })
        }, _toDisplayString(item), 11, _hoisted_1);
      }), 256))], 2);
    };
  }
});